import React from 'react';
import moment from 'moment';

const ICONS = {
  clear: require('./img/weather/clear.png'),
  clouds: require('./img/weather/clouds.png'),
  fewclouds: require('./img/weather/fewclouds.png'),
  rain: require('./img/weather/rain.png'),
  snow: require('./img/weather/snow.png'),
};

function formatTemp (temp) {
  if (temp == null) return '-';
  return temp.toFixed(0);
}

export default class Weather extends React.Component {

  render () {
    let weather = this.props.weather;
    if (weather == null || weather[0] == null) return null;
    let current = weather[0],
        day = moment(current.time).format('dddd'),
        date = moment(current.time).format('DD.MM.YYYY.');
    return (
      <div className="Weather">
        <p className="date"><b>{ day }</b> / { date }</p>
        <p className="status">
          <img src={ICONS[current.icon]} alt="" />
          <span> {formatTemp(current.temp)}°c</span>
        </p>
        <div className="next">
          <SmallWeather key="1" weather={weather[1]} />
          <SmallWeather key="2" weather={weather[2]}/>
          <SmallWeather key="3" weather={weather[3]} />
        </div>
      </div>
    );
  }
}

class SmallWeather extends React.Component {

  render () {
    let w = this.props.weather;
    if (w == null) return <div className="SmallWeather" />

    let day = moment(w.time).format('ddd'),
        date = moment(w.time).format('DD.MM.');
    return (
      <div className="SmallWeather">
        <p className="day">{ day }</p>
        <p className="date">{ date }</p>
        <img src={ICONS[w.icon]} alt="" />
        <p className="status"> {formatTemp(w.temp)}°c</p>
      </div>
    );
  }
}
